const languages = {
    "FR": "Français",
    "GB": "English",
    "MT": "Malti",
    "PT": "Português",
    "US": "United States",
};
export default (languages);
